<template>
  <el-dialog :title="showOption ? '上传附件' : '查看附件'" :visible.sync="visible" width="60%">
    <zg-upload
      ref="upload"
      class="m-b20"
      accept="annex"
      :disabled="!showOption"
      :show-tip="showOption"
      :file-list="fileList"
      :max-size="1024 * 1024 * 2"
      @change="files => (fileList = files)"
    ></zg-upload>
    <div v-if="showOption" slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" :disabled="!fileList.length" @click="confirmDialog"
        >确 认</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import ZgUpload from '@/components/zg-upload.vue'

export default {
  name: 'UploadInvoiceDialog',
  components: {
    ZgUpload
  },
  props: {
    rowIndex: {
      type: Number,
      default: 0
    },
    showOption: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      fileList: [],
      visible: false
    }
  },
  watch: {
    visible(bool) {
      !bool && (this.fileList = [])
    }
  },
  methods: {
    uploadChange(file) {
      this.fileList.push(file)
    },
    confirmDialog() {
      const { fileList, rowIndex } = this
      if (fileList.length > 6) {
        this.$message.warning('附件不能超过6个')
        return false
      }
      this.$emit('confirm', {
        fileList: fileList.map(x => ({ ...x, fileKey: x.fk })),
        rowIndex
      })
      this.visible = false
    }
  }
}
</script>

<style scoped></style>
